'use strict';

/* jshint esnext: true, loopfunc: true */

var checkType = require('./type');

var isString = checkType.isString;
var stringPrototype = String.prototype;

function toString(a) {
    return a.toString();
}

var stringUtils = {
    isString: isString,
    trim: function trim(str) {
        str = toString(str);
        return stringPrototype.trim ? str.trim() : str.replace(/^\s+|\s+$/g, '');
    },
    trimLeft: function trimLeft(str) {
        str = toString(str);
        return stringPrototype.trimLeft ? str.trimLeft() : str.replace(/^\s+/g, '');
    },
    trimRight: function trimRight(str) {
        str = toString(str);
        return stringPrototype.trimRight ? str.trimRight() : str.replace(/^\s+/g, '');
    },
    lc: function lc(str) {
        return toString(str).toLowerCase();
    },
    uc: function uc(str) {
        return toString(str).toUpperCase();
    },
    hasSubString: function hasSubString(str, subStr) {
        return toString(str).indexOf(toString(subStr)) > -1;
    }
};

module.exports = stringUtils;


/*****************
 ** WEBPACK FOOTER
 ** ./~/zero-lang/string.js
 ** module id = 33
 ** module chunks = 0
 **/